export default __webpack_public_path__ + "static/media/verySad.04559edb.png";